class PdpGallery {
  init() {
    const gallery = document.getElementById('pdp-product-gallery')

    if (!gallery) {
      return
    }

    const thumbnails = gallery.querySelectorAll('[data-gallery-thumb-index]')

    const applyVideoAspect = (videoEl) => {
      const slide = videoEl.closest('.pdp-gallery__slide--video')

      if (!slide || !videoEl.videoWidth || !videoEl.videoHeight) {
        return
      }

      slide.style.aspectRatio = `${videoEl.videoWidth} / ${videoEl.videoHeight}`
    }

    gallery.querySelectorAll('.pdp-gallery__slide--video video').forEach((videoEl) => {
      const syncAspect = () => applyVideoAspect(videoEl)

      if (videoEl.readyState >= 1) {
        syncAspect()
      }

      videoEl.addEventListener('loadedmetadata', syncAspect)
    })

    const syncVideosForActiveIndex = (activeIndex) => {
      gallery.querySelectorAll('.pdp-gallery__slide video').forEach((videoEl) => {
        const slide = videoEl.closest('.pdp-gallery__slide')
        const slideIndex = parseInt(slide?.dataset.galleryIndex || '-1', 10)

        if (slideIndex !== activeIndex) {
          videoEl.pause()
          return
        }

        // Muted autoplay satisfies browser policies when selecting/scrolling to the slide.
        videoEl.muted = true
        videoEl.playsInline = true

        const playPromise = videoEl.play()

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            // Autoplay can still be blocked; leave controls available for manual play.
          })
        }
      })
    }

    const setActiveIndex = (index, options = {}) => {
      const { fromEmbla = false } = options
      const normalizedIndex = Number.isFinite(index) ? index : 0

      gallery.dataset.activeIndex = String(normalizedIndex)

      thumbnails.forEach((thumbnail) => {
        const thumbIndex = parseInt(thumbnail.dataset.galleryThumbIndex, 10)
        const isActive = thumbIndex === normalizedIndex

        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false')
        thumbnail.classList.toggle('is-active', isActive)
      })

      syncVideosForActiveIndex(normalizedIndex)

      if (!fromEmbla) {
        const emblaApi = window.emblaApis?.['pdp-product-gallery']

        if (emblaApi) {
          emblaApi.scrollTo(normalizedIndex)
        }
      }
    }

    window.pdpGallerySetActiveIndex = setActiveIndex

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        setActiveIndex(parseInt(thumbnail.dataset.galleryThumbIndex, 10))
      })
    })

    setActiveIndex(parseInt(gallery.dataset.activeIndex || '0', 10))
  }
}

export { PdpGallery }
